// Core filter function
function filterBanners({ banners, screenType, bannerType, isMobile }) {
  return banners
    .filter((banner) => {
      const matchScreen = banner.screenType === screenType
      const matchType = banner.bannerType === bannerType
      const matchMobile =
        typeof isMobile === "boolean" ? banner.isMobile === isMobile : true
      return banner.enabled && matchScreen && matchType && matchMobile
    })
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
}

// Main screen exports
export function getMainLargeBanners(banners = []) {
  return filterBanners({
    banners,
    screenType: "main",
    bannerType: "large"
  })
}

export function getMainSmallBanners(banners = []) {
  return filterBanners({
    banners,
    screenType: "main",
    bannerType: "small"
  })
}

// Casino screen exports
export function getCasinoLargeBanners(banners = []) {
  return filterBanners({
    banners,
    screenType: "casino",
    bannerType: "large"
  })
}

export function getCasinoSmallBanners(banners = []) {
  return filterBanners({
    banners,
    screenType: "casino",
    bannerType: "small"
  })
}

// Sportsbook screen exports
export function getSportsbookLargeBanners(banners = []) {
  return filterBanners({
    banners,
    screenType: "sportsbook",
    bannerType: "large"
  })
}

export function getSportsbookSmallBanners(banners = []) {
  return filterBanners({
    banners,
    screenType: "sportsbook",
    bannerType: "small"
  })
}

export { filterBanners }
